
import { IAccount } from '@share/common-types';
import isEmpty from 'lodash/isEmpty';
import { ILoginState } from '@share/store/slices';

export const GetPreferenceValue = (account: IAccount, key: string, defaultValue: any = null) => {
  if (!isEmpty(account?.preferences)) {
    const prefDB: any = account?.preferences.find(p => p.key === key);
    if (prefDB) {
      return prefDB.value;
    }
  }
  return defaultValue;
}

export const GetPreferenceValueParsed = (account: IAccount, key: string, defaultValue: any = null) => {
  const pref = GetPreferenceValue(account, key, defaultValue);
  if (pref) {
    return JSON.parse(pref);
  }
  return null;
}

export const GetMultipleCitiesEnabled = (loginStore: ILoginState) => {

  const siteId = loginStore?.user?.userAdditionalData?.siteID;
  const organizationId = loginStore?.user?.userAdditionalData?.organizationId;
  const account = loginStore?.account as IAccount;

  const toNumberArray = (val?: string): number[] =>val?.split(',').map(v => Number(v.trim())).filter(Boolean) ?? [];
  const hasMultipleCities = GetPreferenceValue(account, 'enable_share_compare_multiple_cities') === 'true';
  const orgIds = toNumberArray(GetPreferenceValue(account, 'enable_share_compare_multiple_cities_orgids'));
  const siteIds = toNumberArray(GetPreferenceValue(account, 'enable_share_compare_multiple_cities_siteids'));
      
  const MultipleCitiesEnable = orgIds.length && siteIds.length
        ? orgIds.includes(organizationId as number) && siteIds.includes(siteId as number)
        : orgIds.length
        ? orgIds.includes(organizationId as number)
        : siteIds.length
        ? siteIds.includes(siteId as number)
        : true;
  const hasMultipleCitiesEnable= hasMultipleCities && MultipleCitiesEnable; 
  return hasMultipleCitiesEnable ? true : false;
}
